import styled from "styled-components";
import React from "react";
import {Experience, Help, ProfileSkillsProps} from "@betrue/ui";
import HighlightOffOutlinedIcon from '@mui/icons-material/HighlightOffOutlined';
import {Grid, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow,} from "@mui/material";
import {ExperienceLevel, ProfileSkill, StyledBaseProps} from "@betrue/shared/interfaces";

export interface ProfileSkillsViewProps extends ProfileSkillsProps, StyledBaseProps {
  deleteProfileSkill: (ps: ProfileSkill) => void
  changeExperience: (ps: ProfileSkill, xp: ExperienceLevel) => void
  profilesSkills?: ProfileSkill[]
}

export const ProfileSkillsView = styled((props: ProfileSkillsViewProps) => (
  <TableContainer className={props.className} style={{maxHeight:'500px',overflow:'scroll'}}>
    <Table stickyHeader size="small" aria-label="a dense table">
      <TableHead>
        <TableRow>
          <TableCell align="left">
            {props.skillsHeader} {props.skillsHeaderHelper ? <Help helpMessage={props.skillsHeaderHelper}/> : ''}
          </TableCell>
          <TableCell align="left">
            {props.experiencesHeader} {props.experiencesHeaderHelper ?
            <Help helpMessage={props.experiencesHeaderHelper}/> : ''}
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody >
        {props.profilesSkills?.sort((a, b) => a.skill.key > b.skill.key ? 1 : -1)
          .map((profileSkill) => (
          <TableRow key={profileSkill.skill.key}>
            <TableCell component="th" scope="row" align="left">
              {profileSkill.skill.label}
            </TableCell>
            <TableCell align="left">
              <Grid container direction="row" justifyContent="flex-start" alignItems="center">
                <Grid item>
                  <Experience  level={profileSkill.experienceLevel} onSelect={props.canUpdate ? (exp) => {
                    props.changeExperience(profileSkill, exp)
                  } : undefined}/>
                </Grid>
                {props.canDelete ?
                  (<Grid item>
                    <IconButton onClick={(e) => props.deleteProfileSkill(profileSkill)}>
                      <HighlightOffOutlinedIcon/>
                    </IconButton>
                  </Grid>)
                  : ''
                }

              </Grid>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </TableContainer>
))``
